<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="8">
        <latest-news v-if="news" :news="news"></latest-news>
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <template v-if="resource">
          <latest-resource :resource="resource"></latest-resource>
          <br />
        </template>
        <survey-list v-if="!user.read_only" :surveys="surveys"></survey-list>
        <poll-list v-if="!user.read_only" :polls="polls"></poll-list>
        <br />
        <v-card>
          <v-card-title>{{ $t("Tapahtumat") }}</v-card-title>

          <eventlist :events="events"></eventlist>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="userIsAdmin" style="position: fixed; right: 20px; bottom: 20px">
      <v-speed-dial v-model="fab">
        <template v-slot:activator>
          <v-btn v-model="fab" color="primary" dark fab>
            <v-icon v-if="fab"> {{ icons.mdiClose }} </v-icon>
            <v-icon v-else> {{ icons.mdiPencil }} </v-icon>
          </v-btn>
        </template>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab dark small color="primary" :to="{ name: 'admin-news-form' }">
              <v-icon>{{ icons.mdiFormatQuoteClose }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Uusi uutinen") }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab dark small color="primary" :to="{ name: 'admin-event-form' }">
              <v-icon>{{ icons.mdiCalendar }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Uusi tapahtuma") }}</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab dark small color="primary" :to="{ name: 'admin-poll-form' }">
              <v-icon>{{ icons.mdiPoll }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Uusi kysely") }}</span>
        </v-tooltip>
      </v-speed-dial>
    </div>
  </div>
</template>

<script>
import useAuth from "@/useAuth";
import api from "@/api";
import { useTranslations } from "@/@core/libs/i18n";
import eventlist from "@/components/events/eventlist.vue";
import latestNews from "@/components/news/latest_news.vue";
import latestResource from "@/components/resources/latest_resource.vue";
import pollList from "@/components/polls/poll_list.vue";
import surveyList from "@/components/surveys/survey_list.vue";
import newslist from "@/components/news/newslist.vue";
import { onMounted, ref } from "@vue/composition-api";
import {
  mdiClose,
  mdiPoll,
  mdiPencil,
  mdiFormatQuoteClose,
  mdiCalendar,
} from "@mdi/js";

export default {
  components: {
    eventlist,
    latestNews,
    latestResource,
    pollList,
    surveyList,
    newslist,
  },
  setup() {
    const { tenant, userIsAdmin, user } = useAuth();
    const { t } = useTranslations();

    const resource = ref({});
    const news = ref([]);
    const events = ref([]);
    const polls = ref([]);
    const surveys = ref([]);
    const fab = ref(null);

    const fetch = async () => {
      const response = await api.getFeed();
      if (response.ok) {
        resource.value = response.data.document;
        if (response.data.news?.length) {
          news.value = response.data.news[0];
        }
        events.value = response.data.events;
        if (!user.value.read_only) {
          polls.value = response.data.polls;
          surveys.value = response.data.surveys;
        }
      }
    };

    onMounted(() => {
      fetch();
    });

    return {
      resource,
      news,
      events,
      polls,
      surveys,
      tenant,
      user,
      userIsAdmin,
      fab,
      t,
      icons: {
        mdiClose,
        mdiPoll,
        mdiPencil,
        mdiFormatQuoteClose,
        mdiCalendar,
      },
    };
  },
};
</script>
